/**
 * TanStack Query hooks for `amazon-advertising-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	amazonAdvertisingIntegrationQueryKeys,
	type CreateAmazonAdvertisingIntegrationBody,
	type ListAmazonAdvertisingIntegrationResponse,
	type AmazonAdvertisingIntegrationRow,
} from "./api";

export function useAmazonAdvertisingIntegrationList(): UseQueryResult<ListAmazonAdvertisingIntegrationResponse, Error> {
	return useQuery({
		queryKey: amazonAdvertisingIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useAmazonAdvertisingIntegrationCreate(): UseMutationResult<AmazonAdvertisingIntegrationRow, Error, CreateAmazonAdvertisingIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: amazonAdvertisingIntegrationQueryKeys.all });
		},
	});
}

export function useAmazonAdvertisingIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: amazonAdvertisingIntegrationQueryKeys.all });
		},
	});
}
